import {Component} from '@angular/core';
import {LoanApplicationService} from '../loan-application.service';
import {AbstractControl, FormControl} from '@angular/forms';
import {MatSnackBar} from '@angular/material';
import {BehaviorSubject} from 'rxjs';
import {Router} from '@angular/router';
import {AnalyticsService} from '../../../analytics.service';
import {LoanApplication} from '../../../@models/loan-application.model';

@Component({
  selector: 'bb-page-two',
  templateUrl: './page-two.component.html',
  styleUrls: ['./page-two.component.scss'],
})
export class PageTwoComponent {
  posting = new BehaviorSubject(false);

  constructor(private loan: LoanApplicationService,
              private router: Router,
              private analytics: AnalyticsService,
              private snackBar: MatSnackBar) {
  }

  backward() {
    this.loan.backward();
  }

  sendLoanApplication() {
    if (this.isValid) {
      this.posting.next(true);
      this.loan
        .postLoanApplication()
        .do(() => this.posting.next(false))
        .subscribe((loan: LoanApplication.Model) => {
          this.analytics.dataLayer({
            virtualPageURL: '/thank-you',
            virtualCustomerType: loan.employment_type,
            virtualtrigger: 'loan_app_success_ok',
            userEmail: this.userEmail,
          });
          this.router.navigate(['/thank-you']);
        }, (e) => {
          const key = Object.keys(e.error)[0].replace(/_/g, " ");
          const info = key ? `Invalid ${key}` : 'Something went wrong'
          this.snackBar.open(`${info}. Please review your information and try again.`, 'Close', {
            duration: 3000, // Toast will close automatically after 3 seconds
          });
          console.error("Received API error:", JSON.stringify(e.error));
          this.posting.next(false);
          this.markAllDirty(this.loan.form);
        });
    } else {
      this.posting.next(false);
      this.markAllDirty(this.loan.form);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  }

  get isValid() {
    return this.loan.form.valid;
  }

  get userEmail() {
    return this.loan.form.get('personal_info.email_addresses.0').value;
  }

  markAllDirty(control: AbstractControl) {
    if (control.hasOwnProperty('controls')) {
      control.markAsDirty();
      const ctrl = <any>control;
      for (const inner of Object.keys(ctrl.controls)) {
        this.markAllDirty(ctrl.controls[inner] as AbstractControl);
      }
    } else {
      (<FormControl>(control)).markAsDirty();
      (<FormControl>(control)).markAsTouched();
    }
  }
}
